import { Link } from "gatsby"
import React from "react"
import IWF from '../components/image-with-fallback'
import instagramIcon from '../images/instagram-icon.svg'
import linkedinIcon from '../images/linkedin-icon.svg'
import githubIcon from '../images/github-icon.svg'
import mediumIcon from '../images/medium-icon.svg'
import discordIcon from '../images/discord-icon.svg'
import soundcloudIcon from '../images/soundcloud-icon.svg'

import './footer.css'

const Footer = ({ siteTitle }) => (  
  <footer className='footer'>
    <div className='footer-divider-aligner'>
      <hr className='footer-divider' />
    </div>
    <div className='footer-content'>
      <div className='footer-left'>
        <a href='https://createsafe.io'className='footer-logo-a'><IWF fileName="cs-wordmark-black" className='footer-logo'/></a>
        <div className='footer-links'>
          <Link to="/management" className='all-link footer-services-link'><span className='footer-services'>artist management</span></Link>
          <Link to="/development" className='all-link footer-services-link'><span className='footer-services'>artist development</span></Link>
          <Link to="/marketing" className='all-link footer-services-link'><span className='footer-services'>artist marketing</span></Link>
        </div>
      </div>
      <div className='footer-right'>
        <div className='footer-icons'>
          <a href="http://instagram.com/createsafe.io" target='_blank'><img src={instagramIcon} className='footer-icon'/></a>
          <a href="https://www.linkedin.com/company/createsafe/" target='_blank'><img src={linkedinIcon} className='footer-icon'/></a>
          <a href="https://medium.com/createsafe" target='_blank'><img src={mediumIcon} className='footer-icon'/></a>
          <a href="https://github.com/createsafe" target='_blank'><img src={githubIcon} className='footer-icon'/></a>
          <a href="https://discordapp.com/invite/Mm3mucx" target='_blank'><img src={discordIcon} className='footer-icon'/></a>
          <a href="https://soundcloud.com/createsafe" target='_blank'><img src={soundcloudIcon} className='footer-icon'/></a>
        </div>
        <span className='copyright-createsafe'>© createsafe 2019</span>
      </div>
    </div>
    </footer>
)

export default Footer
